module.exports = __webpack_public_path__ + "img/1580953569.3dbe3e3b.jpg";